import React from "react";
import { Routes, Route } from "react-router-dom";

import AppRoutes from "./routes/AppRoutes";
import { CartProvider } from "../src/webview/context/CartContext";

import StartPage from "../src/webview/pages/StartPage";
import ProductsPage from "../src/webview/pages/ProductList";

export default function App() {
  return (
    <CartProvider>
      <Routes>
        {/* Start Page */}
        <Route path="/start/:token" element={<StartPage />} />

        {/* Product List */}
        <Route
          path="/partners/:restaurantId/products"
          element={<ProductsPage />}
        />

        {/* Other Routes */}
        <Route path="/*" element={<AppRoutes />} />
      </Routes>
      
    </CartProvider>
  );
}